<ndt-add-role-view
   [callState]="callState | async"
   [form]="form"
   [accountId]="accountId | async"
   (formCanceled)="onCloseClick()"
   (formSubmitted)="onCreate()"
>
</ndt-add-role-view>
